"use client"

import { X } from "lucide-react"
import avatarIcon from "../../assets/icons/avatar.svg"
import Button from "../shared/Button"

export default function UploadPhotoModal({ isOpen, onClose, onUploadDrive, onUploadDevice }) {
  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
		<div
			className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
			onClick={handleBackdropClick}
		>
			{/* Backdrop */}
			<div className="absolute inset-0 bg-black/70" />

			{/* Modal container */}
			<div className="relative z-10 flex flex-col w-full max-w-[490px] px-4 sm:px-0 pt-[30px] sm:pt-[40px] pb-[20px] sm:pb-[30px] items-center gap-[20px] sm:gap-[30px] shrink-0 rounded-[22px] bg-white shadow-2xl">
				{/* Close button */}
				<button
					onClick={onClose}
					className="absolute top-3 right-3 sm:top-4 sm:right-4 w-5 h-5 bg-dark-blue/40 hover:bg-dark-blue/80 rounded-full flex items-center justify-center transition-colors"
				>
					<X className="w-3 h-3 text-white" />
				</button>

				{/* Profile image area */}
				<div className="flex w-[100px] h-[100px] sm:w-[140px] sm:h-[140px] p-[15px] sm:p-[22.4px] justify-center items-center rounded-full border border-lightGrey">
					<img src={avatarIcon} alt="profile" className="w-full h-full rounded-full object-cover" />
				</div>

				{/* Text Section */}
				<div className="flex flex-col items-center gap-2 px-2 sm:px-6 text-center">
					<h2 className="text-lg sm:text-[25px] font-bold text-dark-blue">Upload a photo of you</h2>
					<p className="text-sm sm:text-[20px] text-gray font-normal">
						Please make sure your photo clearly shows your face. Upload square 1:1 photo.
					</p>
				</div>

				{/* Buttons */}
				<div className="flex flex-col gap-3 sm:gap-4 w-full px-2 sm:px-6">
					{/* <button
            onClick={onUploadDrive}
            className="flex h-[50px] sm:h-[55px] w-full justify-center items-center rounded-[10px] text-white font-medium md:text-[18px] text-[16px]"
            style={{ background: "linear-gradient(90deg, #F36E49 0%, #B67FE2 100%)" }}
          >
            Upload from Google Drive
          </button> */}

					<Button
						onClick={onUploadDevice}
						className="flex-1 flex justify-center items-center h-[55px] rounded-[10px] font-medium text-[16px] sm:text-[18px] border relative overflow-hidden"
						variant="outline-gradient-text"
					>
						Choose from device
					</Button>
				</div>
			</div>
		</div>
	);
}
